import { CommonModule } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MdbCollapseModule } from 'mdb-angular-ui-kit/collapse';
import { MdbSidenavModule } from 'mdb-angular-ui-kit/sidenav';
import { Utente } from 'src/app/models/rbac/Utente';
import { UtenteService } from 'src/app/services/utente.service';

@Component({
  selector: 'app-navigation',
  standalone: true,
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  imports: [MdbSidenavModule, CommonModule, MdbCollapseModule,
    RouterModule
  ]
})
export class NavigationComponent implements OnInit {
  hidden = window.innerWidth >= 660 ? false : true;
  loggato = false
  @Input() utente!: Utente

  constructor(private servUtente: UtenteService,
    @Inject(Router) private route: Router) {
    servUtente.isLogin.subscribe(utente => {
      this.utente = utente
      this.loggato = utente.getTipoUt() != 'guest'
    })
  }

  ngOnInit(): void {
    this.loggato = this.servUtente.isLogged()
  }


  logout() {
    this.servUtente.logout()
    this.route.navigate(['/login'])
  }

}
